import script from "./AccountTabContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountTabContent.vue?vue&type=script&lang=ts&setup=true"

import "./AccountTabContent.vue?vue&type=style&index=0&id=4d976f73&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d976f73"]])

export default __exports__